const userRole = {
  admin_assurance: "admin_assurance",
  agent_assurance: "agent_assurance",
  medecin_assurance: "medecin_assurance",

  admin_clinique: "admin_clinique",
  agent_clinique: "agent_clinique",
  medecin_clinique: "medecin_clinique",

  admin_pharmacie: "admin_pharmacie",
  agent_pharmacie: "agent_pharmacie",

  admin_laboratoire: "admin_laboratoire",
  agent_laboratoire: "agent_laboratoire",

  admin_clinique_laboratoire: "admin_clinique_laboratoire",
  agent_clinique_laboratoire: "agent_clinique_laboratoire",
  medecin_clinique_laboratoire: "medecin_clinique_laboratoire",
};

export { userRole };
